import { render } from "./subscribe-details.vue?vue&type=template&id=61b7c0f4&scoped=true&ts=true"
import script from "./subscribe-details.vue?vue&type=script&lang=ts"
export * from "./subscribe-details.vue?vue&type=script&lang=ts"

import "./subscribe-details.vue?vue&type=style&index=0&id=61b7c0f4&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b7c0f4"]])

export default __exports__